import { Alert, Form, Modal } from 'antd';
import React, { useMemo, useState } from 'react';
import useOngoingOrder from '../hooks/context/useOngoingOrder';
import {
  PhoneNumberHelpers,
  PhoneNumberType,
} from '../services/utils/phone-number/PhoneNumberHelpers';
import { ModalProps } from 'antd/es/modal/interface';
import { CreateOrderData } from '../services/api/OrderService';
import PhoneNumberInput from '../components/form/PhoneNumberInput';

const PhoneNumberForceRenderKey = 'order_confirmation.customer_phone_number';

type Props = Pick<ModalProps, 'open' | 'onClose'> & {
  onClose: () => void;
  onConfirm: (extra: Partial<CreateOrderData>) => void;
};

export default function OrderConfirmationModal({ open, onClose, onConfirm }: Props) {
  const { orderData, updateOrderData } = useOngoingOrder();

  const [phoneNumber, setPhoneNumber] = useState(orderData.customer.phone_number ?? '');

  const isLandline = useMemo(
    () =>
      phoneNumber.length >= 6 &&
      PhoneNumberHelpers.classifyPhoneNumber(phoneNumber) === PhoneNumberType.Landline,
    [phoneNumber],
  );

  const _onConfirm = () => {
    updateOrderData('customer.phone_number', phoneNumber);
    onConfirm({ customer_phone_number: phoneNumber });
    onClose();
  };

  return (
    <Modal
      title="Order details confirmation"
      open={open}
      onCancel={onClose}
      okButtonProps={{ disabled: isLandline, onClick: _onConfirm }}
    >
      <Alert
        type="info"
        className="mb-lg"
        message="Please confirm customer mobile phone number to receive payment link for the order"
      />
      <Form layout="vertical">
        <Form.Item label="Phone number">
          {isLandline && (
            <Alert
              showIcon
              type="error"
              className="mb-sm"
              message="This seems to be a landline phone number. Please enter a mobile phone number so that we can send a SMS with a payment link"
            />
          )}
          <PhoneNumberInput
            distinct
            country="de"
            enableSearch
            preferredCountries={['de']}
            forwardKey={PhoneNumberForceRenderKey}
            value={phoneNumber}
            onChange={setPhoneNumber}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
